import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export default function AdminFormDialog({ account, open, onOpenChange, onSave, saving }) {
  const editing = Boolean(account);
  const [form, setForm] = useState({ name: "", email: "", password: "" });

  useEffect(() => {
    if (open) setForm({ name: account?.name || "", email: account?.email || "", username: account?.username || "", password: "" });
  }, [account, open]);

  const submit = (event) => {
    event.preventDefault();
    const values = { name: form.name.trim(), email: form.email.trim().toLowerCase() };
    if (form.username?.trim()) values.username = form.username.trim().toLowerCase();
    if (form.password) values.password = form.password;
    onSave(values);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="rounded-none">
        <DialogHeader>
          <DialogTitle className="font-heading">{editing ? "Edit Admin" : "Tambah Admin"}</DialogTitle>
          <DialogDescription>{editing ? "Kosongkan password jika tidak ingin menggantinya." : "Buat akun baru dengan role admin."}</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label htmlFor="admin-name" className="block text-sm font-medium mb-2">Nama</label>
            <Input id="admin-name" required maxLength={120} value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="rounded-none" />
          </div>
          <div>
            <label htmlFor="admin-email" className="block text-sm font-medium mb-2">Email</label>
            <Input id="admin-email" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="rounded-none" />
          </div>
          <div>
            <label htmlFor="admin-password" className="block text-sm font-medium mb-2">Password{editing ? " baru" : ""}</label>
            <Input id="admin-password" type="password" required={!editing} minLength={8} autoComplete="new-password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="rounded-none" />
            <p className="text-xs text-muted-foreground mt-1">Minimal 8 karakter.</p>
          </div>
          <div>
            <label htmlFor="admin-username" className="block text-sm font-medium mb-2">Username (opsional)</label>
            <Input id="admin-username" value={form.username || ""} onChange={(e) => setForm({ ...form, username: e.target.value })} minLength={3} maxLength={50} className="rounded-none" />
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)} disabled={saving} className="rounded-none">Batal</Button>
            <Button type="submit" disabled={saving} className="rounded-none">{saving ? "Menyimpan..." : "Simpan"}</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
